(function () {
  const FEE_VARIANT_ID = 56318900568443;
  const DESTINATION_KEY = "delivery_destination";
const WARNING_DISMISSED_KEY = "eu_destination_warning_dismissed";
  const CATEGORY_TO_HS = {
    "Accessories": "3926.40.0000",
    "Adhesives": "3506.10.0000",
    "Blending Brushes": "9603.30.1000",
    "Brushes": "9603.30.1000",
    "Cardstock": "4802.57.0000",
    "Craft Tools": "8205.59.8000",
    "Die Cutting": "8207.30.6032",
    "Embellishments": "3926.90.4000",
    "Embossing Folders": "3926.10.0000",
    "Embossing Pastes": "3407.00.2000",
    "Embossing Powders": "3304.91.0000",
    "Envelopes": "4817.10.0000",
    "Fabric": "5602.00.0000",
    "Hot Foil Plates": "8442.50.0000",
    "Hot Foils": "3213.10.0000",
    "Ink Pads": "9612.20.0000",
    "Ink Sprays": "3215.90.7000",
    "Kits": "9611.00.0000",
    "Markers": "9608.20.0000",
    "Paints": "3213.10.0000",
    "Paper Packs": "4823.90.8500",
    "Patterns": "4909.00.0000",
    "Press Plates": "8442.50.0000",
    "Re-inkers": "3215.90.1000",
    "Stamps": "9611.00.0000",
    "Stencil-Mates": "4802.57.0000",
    "Stencils": "9017.20.8080",
    "Storage": "3923.10.9000",
    "Toner Foils": "3212.10.0000",
    "Toner Sheets": "4802.57.0000",
    "Washi Tapes": "3919.10.8000",
    "Wax Melting": "3406.00.0000",
    "Wax Stamping": "3406.00.0000",
    "Wool/Yarn": "5509.00.0000"
  };

function getDestination() {
  return localStorage.getItem(DESTINATION_KEY);
}

function saveDestination(destination) {
  localStorage.setItem(DESTINATION_KEY, destination);
}

function toggleDutyInfo(destination) {
  const box = document.getElementById("eu-duty-info");
  if (!box) return;
  box.style.display = destination === "EU" ? "block" : "none";
}
function showDestinationWarningIfNeeded(destination) {
  const box = document.getElementById("destination-warning-box");

  if (!box) return false;

  const warningDismissed = sessionStorage.getItem(WARNING_DISMISSED_KEY) === "true";

  if ((destination === "UK" || destination === "ROW") && !warningDismissed) {
    box.style.display = "block";
    return true;
  }

  box.style.display = "none";
  return false;
}
function setMessage(html) {
  const message = document.getElementById("eu-duty-details");
  if (message) message.innerHTML = html || "";
}

function setCheckout(enabled) {
  const button = document.getElementById("checkout-button");
  const additionalButtons = document.getElementById("additional-checkout-buttons");

  if (button) {
    button.disabled = !enabled;
    button.style.opacity = enabled ? "1" : "0.5";
    button.style.cursor = enabled ? "pointer" : "not-allowed";
  }

  if (additionalButtons) {
    additionalButtons.style.display = enabled ? "block" : "none";
  }
}

function restoreSelectedDestination() {
  const saved = getDestination();

  if (!saved) {
    setCheckout(false);
    toggleDutyInfo("");
    return;
  }

  const radio = document.querySelector(
    'input[name="delivery_destination"][value="' + saved + '"]'
  );

if (radio) radio.checked = true;
toggleDutyInfo(saved);
showDestinationWarningIfNeeded(saved);
setCheckout(true);
}

async function getCart() {
  const response = await fetch("/cart.js?t=" + Date.now(), {
    cache: "no-store"
  });
  return response.json();
}

function getDutyData(cart) {
  const seenHsCodes = {};
  const productTypes = [];

  cart.items.forEach(function (item) {
    if (item.variant_id === FEE_VARIANT_ID) return;

    const productType = item.product_type ? item.product_type.trim() : "";
    const hsCode = CATEGORY_TO_HS[productType];

    if (hsCode && !seenHsCodes[hsCode]) {
      seenHsCodes[hsCode] = true;
      productTypes.push(productType);
    }
  });

  return {
    quantity: productTypes.length,
    productTypes: productTypes
  };
}

async function setDutyQuantity(quantity) {
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: String(FEE_VARIANT_ID),
      quantity: quantity
    })
  });
}

async function addDutyQuantity(quantity) {
  await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [{ id: FEE_VARIANT_ID, quantity: quantity }]
    })
  });
}

function renderEuMessage(dutyData) {
  if (!dutyData || dutyData.quantity === 0) {
    setMessage("");
    return;
  }

  const list = dutyData.productTypes
    .map(function (type) {
      return "<li><span>✓</span>" + type + "</li>";
    })
    .join("");

  setMessage(
    "<div class='eu-duty-result'>" +
      "<strong>Import duty applies to " +
        dutyData.quantity +
        " product categor" +
        (dutyData.quantity === 1 ? "y" : "ies") +
      "</strong>" +
      "<ul class='eu-duty-type-list'>" +
        list +
      "</ul>" +
      "<p class='eu-duty-success'>EU import duty has been added automatically.</p>" +
    "</div>"
  );
}

async function refreshDuty(options) {
  const shouldReload = options && options.reload;
  const destination = getDestination();

  try {
    setCheckout(false);
    toggleDutyInfo(destination);
    setMessage(destination === "EU" ? "Calculating EU import duty..." : "");

    const cart = await getCart();

    const dutyItem = cart.items.find(function (item) {
      return item.variant_id === FEE_VARIANT_ID;
    });

    const currentDutyQty = dutyItem ? dutyItem.quantity : 0;
    const dutyData = destination === "EU" ? getDutyData(cart) : { quantity: 0, productTypes: [] };
    const requiredDutyQty = dutyData.quantity;

    if (currentDutyQty !== requiredDutyQty) {
      if (dutyItem) {
        await setDutyQuantity(requiredDutyQty);
      } else if (requiredDutyQty > 0) {
        await addDutyQuantity(requiredDutyQty);
      }

      if (shouldReload) {
        window.location.href = "/cart?eu_duty_refresh=" + Date.now() + "#eu-import-fee-box";
        return;
      }
    }

    if (destination === "EU") {
      renderEuMessage(dutyData);
    } else {
      setMessage("");
    }

    setCheckout(true);

  } catch (error) {
    console.error("EU duty error:", error);
    setMessage("Sorry, there was a problem updating the basket. Please refresh and try again.");
    setCheckout(false);
  }
}

document.addEventListener("change", function (event) {
  if (!event.target.matches('input[name="delivery_destination"]')) return;

  const destination = event.target.value;

saveDestination(destination);
toggleDutyInfo(destination);
showDestinationWarningIfNeeded(destination);
refreshDuty({ reload: true });

});

function runDutyCheckOnPageLoad() {
  restoreSelectedDestination();

  const saved = getDestination();
  toggleDutyInfo(saved);

  if (saved === "EU") {
    setTimeout(function () {
      refreshDuty({ reload: true });
    }, 200);
  }
}
document.addEventListener("click", function (event) {
  if (event.target.id === "switch-to-eu-btn") {
    const euRadio = document.querySelector('input[name="delivery_destination"][value="EU"]');

    if (euRadio) {
      euRadio.checked = true;
      saveDestination("EU");
      toggleDutyInfo("EU");

      const box = document.getElementById("destination-warning-box");
      if (box) box.style.display = "none";

      refreshDuty({ reload: true });
    }
  }

if (event.target.id === "continue-selected-btn") {
  sessionStorage.setItem(WARNING_DISMISSED_KEY, "true");

  const box = document.getElementById("destination-warning-box");
  if (box) box.style.display = "none";

  setCheckout(true);
}});
document.addEventListener("DOMContentLoaded", runDutyCheckOnPageLoad);
window.addEventListener("pageshow", runDutyCheckOnPageLoad);


})();